goog.provide('el8.uiwidget.FeedData');

goog.require('el8.util.base');
goog.require('el8.uiwidget.FeedPage');


//========================================================
// Key helper class for the Feed object.
// Maintains the main index structure and data for the Feed
//========================================================
el8.uiwidget.FeedData = function(spec) {

    spec = spec || {};

    /**
     * Params to set
     */
    this._defaultPageSize = spec.pageSize || 0; /* page size of 0 interpreted as null */

    /**
     * fetchFn needs to be specified as follows:
     *  - first argument is an array (or single argument),
     *  - second argument is whether to "force" fetch from server (defaults to false)
     *  - third argument is whether call is async (defaults to false)
     *  - returns either single obj or array, depending on first arg passed in
     */
    this._fetchFn = spec.fetchFn || function(arg) { return arg; };

    /***************
     * Holds state *
     ***************/
    this._pageSize = null;
    this._indexLoaded = false;
    this._positionById = {};

    /* Expect to be a list of objects with at least 'id' key
     * and 'feed_date' key if we expect to use date navigation */
    this._dataIndex = [];

    /**
     * A function that takes a data index item and returns true if the FeedData should
     * be responsible for fetching its corresponding full data. In particular, this should
     * be used if you want some of the items in the data index to be fetched & rendered by
     * React - those items should be indicated as fetch-**ineligible** (return false)by
     * this function so sole responsibility for fetching that data can live in React.
     * 
     * By default, FeedData is responsible for fetching the full data for all of its data
     * index items. In other words, the default value of this function is a function that
     * always returns true.
     */
    this._shouldFetchItemFn = spec.shouldFetchItemFn || function() { return true; };
};

//========================================================
// MANAGE FEED INDEX
// - Note that we don't intend for FeedData to be smart
//   enough to know how to place items into the index, so
//   there isn't any method to add (because we don't know
//   how to sort)
//========================================================
el8.uiwidget.FeedData.prototype.loadIndex = function(index) {
    this._indexLoaded = true;
    this._dataIndex = index;
    /* If no specified page size for this feed, just reset to the index size */
    this._pageSize = this._defaultPageSize ? this._defaultPageSize : this._getIndexSize();
    this._buildPositionById();
};
el8.uiwidget.FeedData.prototype._buildPositionById = function() {
    this._positionById = {};
    for (var i=0; i<this._dataIndex.length; i++) {
        this._positionById[this._dataIndex[i]['id']] = i;
    }
};
el8.uiwidget.FeedData.prototype.countItems = function() {
    try {
        if (!this._indexLoaded) {
            throw new Error('trying to countItems before load index');
        }
        return this._getIndexSize();
    } catch (e) {
        // DEBUGGING: trying to get a stack trace here to understand the bug better
        var msg = (e.stack) ? e.stack : e.message;
        UIM && UIM.logError(msg);
        return 0;
    }
};
el8.uiwidget.FeedData.prototype.hasItem = function(itemId) {
    return !el8.util.isNone(this._positionById[itemId]);
};
el8.uiwidget.FeedData.prototype.isEmpty = function() {
    return (this.countItems() === 0);
};
el8.uiwidget.FeedData.prototype.removeFromIndex = function(itemId) {
    var position = this._positionById[itemId];
    if (!el8.util.isNone(position)) {
        this._dataIndex.splice(position, 1);
        this._buildPositionById();
        return true;
    }
    return false;
};
el8.uiwidget.FeedData.prototype._getIndexSize = function() {
    return this._dataIndex.length;
};
el8.uiwidget.FeedData.prototype.getSubIndex = function(page) {
    var start = page.getStart();
    var size = page.getSize();
    return this._getIndexSize() ? this._dataIndex.slice(start, start+size) : [];
};
el8.uiwidget.FeedData.prototype.isIndexLoaded = function() {
    return this._indexLoaded;
};
el8.uiwidget.FeedData.prototype.getDataIndex = function() { return this._dataIndex; };
el8.uiwidget.FeedData.prototype.getPositionById = function(itemId) {
    return this._positionById[itemId];
};
el8.uiwidget.FeedData.prototype.getIndexedItemById = function(itemId) {
    return this._dataIndex[this._positionById[itemId]];
};
el8.uiwidget.FeedData.prototype.reset = function() {
    this._dataIndex = [];
    this._indexLoaded = false;
    this._positionById = {};
};


//========================================================
// MANAGE PAGE FETCHING FROM INDEX
//========================================================
el8.uiwidget.FeedData.prototype.getNextPage = function(currPage, id) {
    /**
     * Given a page, render the "next" page. If "id" param is not specified,
     * then "next" page will include up to this._pageSize items. If "id" is
     * specified, then "next" page will include items all the way until the
     * item with the given "id" is reached (or the end of the index).
     */
    var page = new el8.uiwidget.FeedPage();
    if (id) {
        var size = 0;
        for (var i=currPage.getEnd(); i<this._getIndexSize(); i++) {
            size++;
            if (this._dataIndex[i]['id']*1 === id*1) { break; }
        }
        page.mimic(currPage).forward(size, this._getIndexSize());
    } else {
        page.mimic(currPage).forward(this._pageSize, this._getIndexSize());
    }
    return page;
};
el8.uiwidget.FeedData.prototype.getPrevPage = function(currPage) {
    var page = new el8.uiwidget.FeedPage();
    page.mimic(currPage).backward(this._pageSize, this._getIndexSize());
    return page;
};
el8.uiwidget.FeedData.prototype.getLastPage = function() {
    return new el8.uiwidget.FeedPage(
        Math.max(0, this._getIndexSize()-this._pageSize),
        Math.min(this._pageSize, this._getIndexSize())
    );
};
el8.uiwidget.FeedData.prototype.getPageByNumber = function(n) {
    // Page indexed by 0
    if (n < 0) { return new el8.uiwidget.FeedPage(0, 0); }
    var start = n*this._pageSize;
    var size = 0;
    if (start > this._getIndexSize() - 1) { // if we've walked off end
        start = Math.max(0, this._getIndexSize() - 1);
    } else {
        size = Math.min(this._pageSize, this._getIndexSize()-start);
    }
    return new el8.uiwidget.FeedPage(start, size);
};
el8.uiwidget.FeedData.prototype.getPageByDate = function(d8) {
    /**
     * Note: this method assumes that the feed index is ordered in
     * reverse chronological order
     *
     * If d8 is found on the last page, then we just return the last page.
     *
     * If this feed has no "feed_date" key in the index items, then return last page
     */
    if (!d8) { return new el8.uiwidget.FeedPage(0, 0); }
    var start = null;
    for (var i=0; i<Math.max(0, this._getIndexSize() - this._pageSize); i++) {
        /* Walk down index until we find a date earlier than the requested date */
        if (this._dataIndex[i]['feed_date'] &&
            el8.util.datecompare.isSameDayOrLater(
                el8.service.tz.toTzDateTime(this._dataIndex[i]['feed_date']), d8)) {
            start = i;
            break;
        }
    }
    if (start === null) { // no match
        return this.getLastPage();
    } else {
        var size = Math.min(this._pageSize, this._getIndexSize()-start);
        return new el8.uiwidget.FeedPage(start, size);
    }
};
el8.uiwidget.FeedData.prototype.isPageFirstItem = function(itemId, page) {
    // Given and item and a page, return true if item is first item on the page,
    // or if index has length 0
    if (this._dataIndex.length === 0) { return true; }
    // We check this condition to be safe, but it should not ever happen
    else if (this._dataIndex.length <= page.getStart()) { return false; }
    return (itemId === this._dataIndex[page.getStart()]['id']);
};


//========================================================
// MANAGE FETCHING OF DATA BASED ON INDEX
//========================================================
el8.uiwidget.FeedData.prototype.fetchDataById = function(itemId, force, async) {
    if (!this.hasItem(itemId)) { return null; }
    var indexedItem = this.getIndexedItemById(itemId);
    if (indexedItem && this._shouldFetchItemFn(indexedItem)) {
        return {
            item: this._fetchFn(indexedItem, force, async),
            indexedItem: indexedItem
        };
    }
    return null;
};
/**
 * @returns {*[]} an array of items that corresponds to the page. Note that **there is no
 * consistent structure enforced here**, any given feed can decide to return whatever
 * shape of items it wants. You'll need to check the `_fetchFn` of the particular
 * feed instance to see what exactly `fetchPage` will return for that feed.
 */
el8.uiwidget.FeedData.prototype.fetchPage = function(page, force, async) {
    // force defaults to false; async defaults to false
    var items = [];
    if (!page.isEmpty()) {
        var subIndex = this.getSubIndex(page).filter(this._shouldFetchItemFn);
        items = this._fetchFn(subIndex, force, async);
    }

    // debugging UIM error
    if (!async) {
        var emptyIndexes = [];
        items.forEach(function(item, idx) {
            if (!item) { emptyIndexes.push(idx); }
        });
        if (emptyIndexes.length) {
            var errStr = 'Empty indexes in FeedDate.fetchPage: ' + emptyIndexes;
            console.log(errStr);
        }
    }
    // debugging UIM error

    return items;
};
el8.uiwidget.FeedData.prototype.prefetchPages = function(currPage) {
    /* Make sure both next and prev page's items are in local cache */
    if (this._fetchFn) {
        var nextPage = this.getNextPage(currPage);
        this.fetchPage(nextPage, false, true);
        var prevPage = this.getPrevPage(currPage);
        this.fetchPage(prevPage, false, true);
    }
};
el8.uiwidget.FeedData.prototype.fetchNthItem = function(n) {
    var obj = this._dataIndex[n];
    if (obj) {
        var fetched = this.fetchDataById(obj['id']*1);
        return fetched ? fetched['item'] : null;
    }
    return null;
};
